import CircularProgress from '@/components/UI/CircularProgress/CircularProgress';
import type { DataTableHighVolumeUpsertEvent, DataTableService } from '@/components/UI/DataTableV2/DataTable.model';
import { DataTableEvent } from '@/components/UI/DataTableV2/DataTable.model';
import { ModalActions, ModalContainer, ModalHeader } from '@/utils/modal';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

interface HighVolumeUpsertModalProps {
  dataTableService: DataTableService;
  closeModal: () => void;
}

const HighVolumeUpsertModal: FC<HighVolumeUpsertModalProps> = ({ dataTableService, closeModal }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const highVolumeUpsertListener = (event: DataTableHighVolumeUpsertEvent): void => {
    const {
      detail: { totalChunkedRequests, resolved },
    } = event;
    const nextProgress = totalChunkedRequests > 0 ? Math.floor((resolved.length / totalChunkedRequests) * 100) : 100;
    setUploadProgress(nextProgress);
  };

  useEffect(() => {
    dataTableService.subscribe(DataTableEvent.HighVolumeUpsert, highVolumeUpsertListener);
    return () => {
      dataTableService.unsubscribe(DataTableEvent.HighVolumeUpsert, highVolumeUpsertListener);
    };
  }, [dataTableService]);

  const isComplete = uploadProgress >= 100;

  return (
    <ModalContainer size="narrow" className="bg-white">
      <ModalHeader title="High volume upsert" className="pa3 bb b--moon-gray w-100" />
      <div className="pa3 tc">
        <h3 className="lh-title normal f4 pb3" data-testid="high-volume-upsert-status">
          {isComplete ? 'Complete!' : 'Saving...'}
        </h3>
        <CircularProgress percent={uploadProgress} status="active" testId="high-volume-upsert-progress" />
      </div>
      <ModalActions
        className="pa3 mt3 bt b--moon-gray"
        cancelBtnText="Close"
        cancelButtonProps={{
          disabled: !isComplete,
        }}
        onCancel={closeModal}
      />
    </ModalContainer>
  );
};

export default HighVolumeUpsertModal;
